import axiosInstance from './api'


export const teamBillingApi = {
async getUserTeamBillings  (page = 1, limit = 20, filters = {}) {
  const response = await axiosInstance.get('/team-billing/user', {
    params: { page, limit, ...filters }
  })
  return response.data
},

async getTeamBillings  (teamId, page = 1, limit = 20, filters = {}) {
  const response = await axiosInstance.get(`/team-billing/team/${teamId}`, {
    params: { page, limit, ...filters }
  })
  return response.data
},

async getTeamBillingById  (id)  {
  const response = await axiosInstance.get(`/team-billing/${id}`)
  return response.data
},

async downloadTeamBillingInvoice  (teamBillingId) {
  const response = await axiosInstance.get(`/team-billing/invoice/${teamBillingId}`, {
    responseType: 'blob'
  })
  return response
},

async confirmPayPalTeamPayment(teamBillingId, orderId, payerId) {
  const response = await axiosInstance.post('/team-billing/paypal/confirm', {
    teamBillingId,
    orderId,
    payerId
  })
  return response.data
},

async recheckPayPalTeamPayment(teamBillingId) {
  const response = await axiosInstance.post(`/team-billing/paypal/recheck/${teamBillingId}`)
  return response.data
},

async getPayPalTeamRedirectUrl(teamBillingId) {
  const response = await axiosInstance.get(`/team-billing/paypal/redirect/${teamBillingId}`)
  return response.data
}   

}